import { WPPost } from "../../../constants/types";
import { HomePageAcf } from "../../../constants/types/acf";
import { fetchRouteData } from "../services";
import { StoreApi } from "../types";
import { setNotificationBarState } from "./ui-state";

export const setRouteData = (route: string, data: WPPost | void) => ({
    getState,
    setState,
}: StoreApi) => {
    const { routes } = getState();
    setState({
        routes: {
            ...routes,
            [route]: data,
        },
    });
};

export const getRouteData = (path: string) => async ({ dispatch }: StoreApi) => {
    try {
        const data = await fetchRouteData(path);
        dispatch(setRouteData(path, data));

        if (path === "/" || path === "") {
            const page = data as WPPost<HomePageAcf>;
            dispatch(setNotificationBarState({ ...page.acf.notification_bar }));
        } else {
            dispatch(setNotificationBarState({ enabled: false }));
        }

        return data;
    } catch (error) {
        // Setting a route to undefined will cause the NotFound component to render
        dispatch(setRouteData(path, undefined));
        console.error("Error fetching route data", { path, error });
    }
};
